import React, { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import SpotlightHeader from '../../Common/Header';
import BottomBar from '../../../components/BottomBar';
import './MultiCelebration.scss';
const PAGE_SIZE = 10;
const STORAGE_KEYS = {
  boh_type_multi_birthday: 'multi-birthday-employee-page',
  boh_type_multi_anniversary: 'multi-anniversary-employee-page'
};
const sortEmployeesByBirthday = employees => {
  return employees.sort((a, b) => a.birthday.localeCompare(b.birthday));
};
const sortEmployeesByAnniversary = employees => {
  return employees.sort((a, b) => {
    const formattedA = DateTime.fromFormat(a.start_date, 'yyyy-MM-dd');
    const formattedB = DateTime.fromFormat(b.start_date, 'yyyy-MM-dd');
    return formattedA.month - formattedB.month || formattedA.day - formattedB.day;
  });
};
const getEmployees = (employees, storage_key, type) => {
  if (!employees) return [];
  const totalPages = Math.ceil(employees.length / PAGE_SIZE);
  const currentPage = +localStorage.getItem(storage_key) || 1;
  const offset = (currentPage - 1) * PAGE_SIZE;
  let sortedEmployees;
  if (type === 'boh_type_multi_birthday') {
    sortedEmployees = sortEmployeesByBirthday(employees);
  }
  if (type === 'boh_type_multi_anniversary') {
    sortedEmployees = sortEmployeesByAnniversary(employees);
  }
  if (!sortedEmployees) return [];
  const pagedEmployees = sortedEmployees.slice(offset, offset + PAGE_SIZE);
  const nextPage = currentPage < totalPages ? currentPage + 1 : 1;
  localStorage.setItem(storage_key, nextPage);
  return pagedEmployees;
};
const formatCelebrationDate = (employee, metadata) => {
  var _dt;
  const showBirthDate = metadata === null || metadata === void 0 ? void 0 : metadata.boh_show_birth_date;
  const showAnniDate = metadata === null || metadata === void 0 ? void 0 : metadata.boh_show_anniversary_date;
  let dt;
  if (showBirthDate && employee.birthday) {
    // 2000 was a leap year
    dt = DateTime.fromFormat(`2000-${employee.birthday}`, 'yyyy-MM-dd');
  }
  if (showAnniDate && employee.start_date) {
    dt = DateTime.fromFormat(employee.start_date, 'yyyy-MM-dd');
  }
  return (_dt = dt) !== null && _dt !== void 0 && _dt.isValid ? dt.toFormat('d MMM') : '';
};
const formatAnniversaryYears = anniversary => {
  if (!anniversary) return '';
  const anniversaryDate = DateTime.fromFormat(anniversary, 'yyyy-MM-dd');
  const difference = Math.abs(anniversaryDate.diffNow('years').years);
  return `${Math.round(difference)} Years`;
};
const formatTitle = (text, metadata, type) => {
  if (type === 'boh_type_multi_anniversary') {
    return metadata.boh_time_range === 'WEEK' ? {
      ...text,
      title: 'This Week\'s Anniversaries'
    } : text;
  }
  if (type === 'boh_type_multi_birthday') {
    return metadata.boh_time_range === 'WEEK' ? {
      ...text,
      title: 'This Week\'s Birthdays'
    } : text;
  }
};
const MultiCelebration = props => {
  const {
    metadata,
    bohStyle,
    text,
    data,
    type
  } = props;
  const [employees, setEmployees] = useState([]);
  const storage_key = STORAGE_KEYS[type];
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  const hideTitle = metadata === null || metadata === void 0 ? void 0 : metadata.boh_hide_title;
  const showAnniversary = metadata === null || metadata === void 0 ? void 0 : metadata.boh_show_anniversary;
  useEffect(() => {
    if (employees.length === 0 || employees[0].name === 'N/A') {
      setEmployees(getEmployees(data.employees, storage_key, type));
    }
  }, [data]);
  const formattedTitle = formatTitle(text, metadata, type);
  const {
    accent_color,
    text_accent_color,
    containerStyle
  } = bohStyle;
  return /*#__PURE__*/React.createElement("div", {
    className: "multi-celebration-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: formattedTitle,
    metadata: metadata,
    hideTitle: hideTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: "celebration-info-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "celebration-info"
  }, employees.map(employee => {
    return /*#__PURE__*/React.createElement("div", {
      key: employee.id,
      className: "celebration-info-title"
    }, /*#__PURE__*/React.createElement("div", {
      className: "employee-name-container"
    }, employee.name), /*#__PURE__*/React.createElement("div", {
      className: "celebration-date-container"
    }, formatCelebrationDate(employee, metadata)), /*#__PURE__*/React.createElement("div", {
      className: "anniversary-years-container"
    }, showAnniversary && formatAnniversaryYears(employee.start_date)));
  }))), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyshift: hide_poweredbyshift
  }));
};
export default MultiCelebration;